// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { Alert, Col, Row } from 'angieslist-react-components';
import { analytics, urlCatalog, tracker, validation } from 'angieslist-app-platform';
import { reduxForm, Field, Form, SubmissionError } from 'redux-form';
import { InputField } from 'angieslist-app-platform/lib/browser/forms';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { connect } from 'react-redux';
import { get } from 'lodash';
import businessDescriptionValidationRules from './businessDescriptionValidationRules';
import businessDescriptionAnalytics from './businessDescriptionAnalytics';
import * as welcomeActions from '../../common/welcomeActions';

const styles = {
  descriptionTextArea: {
    minHeight: 225,
  },
};

/* eslint react/prefer-stateless-function: 0 */
export class BusinessDescriptionFormComponent extends React.Component<*> {
  constructor(props: any) {
    super(props);
    this.updateBusinessDescriptionAndTrack = this.updateBusinessDescriptionAndTrack.bind(this);
  }

  props: {
    handleSubmit: (submitFn: (values: any) => Promise<any>) => void,
    serviceProviderId: number,
    error: any,
    welcomeStore: any,
    updateBusinessDescription:
      (serviceProviderId: number, businessDescription: string) => Promise<any>
  }

  // Need to explicitly define this as a function; method notation causes flow errors
  updateBusinessDescriptionAndTrack: any | ((values: any) =>
  Promise<void | any>) = (values: any) => {
    const { serviceProviderId, updateBusinessDescription } = this.props;
    return updateBusinessDescription(serviceProviderId, values.businessDescription)
      .then(() => {
        tracker.track('Item Clicked', {
          serviceProviderId,
          description: 'Welcome Business Description',
          activityLocation: 'SP : Welcome Business Description',
          userId: get(this, 'props.user.userInfo.response.userId'),
        });
      })
      .catch(() => {
        const errorMessage = (<span>There was a problem updating your business description.  Please contact us at <a id="welcome-view--add-business-description--error-link" href={urlCatalog.global.businessCenterPhone()}>{urlCatalog.global.businessCenterPhoneText()}</a> for assistance.</span>);
        throw new SubmissionError({ _error: errorMessage });
      });
  }

  render(): Element<"div"> {
    const { handleSubmit, error, welcomeStore } = this.props;
    const isLoading = get(welcomeStore, 'updateBusinessDescription.isLoading');
    return (
      <div>
        <Form onSubmit={handleSubmit(this.updateBusinessDescriptionAndTrack)}>
          <If condition={error}>
            <Alert bsStyle="danger">{error}</Alert>
          </If>
          <Row>
            <Col xs={12}>
              <h5>
                Your business description is one of the first things a member sees about your
                business. Include a clear, detailed overview of your business:
              </h5>
              <ul>
                <li>
                  <strong>Start with your specialties and overview of services.</strong> This
                  helps the member decide quickly if you can do their job.
                </li>
                <li>
                  <strong>State your value proposition.</strong> What makes you stand out from
                  your competitors?
                </li>
                <li>
                  <strong>Sell your background and staff.</strong> How long have you been in
                  business or in this line of work? Are you owner-operated or a large business?
                </li>
                <li>
                  <strong>Avoid using terms that are specific to your industry.</strong> Potential
                  customers may not be familiar with these.
                </li>
              </ul>
            </Col>
          </Row>
          <Loader
            loading={isLoading}
            element={
              <Row className="category-row text-center">
                <i className="icon icon-load icon-spin icon-3x text-primary" />
              </Row>
          }
          >
            <Row>
              <Col xs={12}>
                <Field
                  name="businessDescription"
                  id="welcome-wizard--business-description"
                  component={InputField}
                  type="textarea"
                  style={styles.descriptionTextArea}
                  autoFocus
                />
              </Col>
            </Row>
          </Loader>
        </Form>
      </div>
    );
  }
}

export default (compose(
  reduxForm({
    form: 'welcomeBusinessDescriptionForm',
    validate:
      values => validation.validate(values, businessDescriptionValidationRules).invalidAttrs,
    destroyOnUnmount: false,
  }),
  connect(
    state => ({
      welcomeStore: state.welcome,
      user: state.user,
    }),
    welcomeActions,
  ),
  analytics({
    ruleset: businessDescriptionAnalytics,
  }),
  pure,
)(BusinessDescriptionFormComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/BusinessDescriptionForm.js